import React, { useState } from 'react';
import Logo from './Logo';
import './LoginForm.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from './AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import axios from './axiosConfig';

const AdminLoginForm: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { setIsLoggedIn, setUsername: setAuthUsername } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const requestData = { username, password };

      // ✅ Admin login endpoint (no IP whitelist)
      const response = await axios.post('/api/login/admin', requestData);

      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem('token', data.token);
        localStorage.setItem('user_type', data.user_type);
        setIsLoggedIn(true);
        setAuthUsername(data.username);
        navigate('/');
        return;
      }

      setError('Invalid username or password');
    } catch (err: any) {
      // If backend returns JSON like {error: "..."} keep it
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        'An unexpected error occurred. Please try again later.';
      setError(msg);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((v) => !v);
  };

  return (
    <div className="form-container">
      <Logo className="logo-style" />
      <form onSubmit={handleLogin}>
        <div className="form-field">
          <label>Email or Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            onInvalid={(e) =>
              e.currentTarget.setCustomValidity('Please enter your email or username')
            }
            onInput={(e) => e.currentTarget.setCustomValidity('')}
          />
        </div>

        <div className="form-field">
          <label>Password:</label>
          <div className="password-container">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              onInvalid={(e) => e.currentTarget.setCustomValidity('Please enter your password')}
              onInput={(e) => e.currentTarget.setCustomValidity('')}
            />
            <button onClick={togglePasswordVisibility} type="button" className="toggle-password">
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        {error && <p className="error-message">{error}</p>}

        <button type="submit" className="login-button">Login</button>

        <Link to="/forgot-password" className="forgot-password-link">
          Forgot Password
        </Link>
      </form>
    </div>
  );
};

export default AdminLoginForm;
